export const SUBSCRIPTION_MAIN_FORM = "config_subscription_main";
export const DELETE_CUSTOMER_SAMPLE_FORM = "configDeleteCustomerSampleForm";